<!-- eslint-disable -->
<template lang="pug">
    .room
        img.detective__background(src='../../../../assets/images/detective/chapter_1/background/background.png')
        .columns.detective__shadows
            .column.left-interlocutor
                img.detective__left-interlocutor__shadow(
                    :class="{'detective__left-interlocutor__shadow_introduction': isIntroduction}",
                    src='../../../../assets/images/detective/chapter_1/background/shadow_clevik.png'
                )
            .column.center-column
            .column.right-interlocutor
                img.detective__right-interlocutor__shadow(src='../../../../assets/images/detective/chapter_1/background/shadow_detective.png')
        img.detective__background(src='../../../../assets/images/detective/chapter_1/background/grid.png')
        img.detective__interior(src='../../../../assets/images/detective/chapter_1/background/interior.png')
        .columns.detective__interlocutors
            .column.left-interlocutor
                transition(name='slide-fade')
                    #left__conversation-image(v-show='leftImageIsSet')
                img.detective__left-interlocutor(:src='clevikSrc')
            .column.center-column
                slot
            .column.right-interlocutor
                transition(name='slide-fade')
                    #right__conversation-image(v-show='rightImageIsSet')
                img.detective__right-interlocutor(
                    :class="{'detective__right-interlocutor_introduction': isIntroduction}",
                    :src='detectiveSrc'
                )
                .detective__items(v-if='!isIntroduction')
                    .detective__items__first-items
                        img.detective__items__magnifier(
                            v-if="items.includes('Magnifier')",
                            src='../../../../assets/images/detective/chapter_1/items/magnifier.png'
                        )
                        img.detective__items__lantern(
                            v-if="items.includes('Lantern')",
                            src='../../../../assets/images/detective/chapter_1/items/lantern.png'
                        )
                    .detective__items__second-items
                        img.detective__items__notepad(
                            v-if="items.includes('Notepad')",
                            src='../../../../assets/images/detective/chapter_1/items/notepad.png'
                        )
                        img.detective__items__camera(
                            v-if="items.includes('Camera')",
                            src='../../../../assets/images/detective/chapter_1/items/camera.png'
                        )
                    .detective__items__third-items
                        img.detective__items__pen(
                            v-if="items.includes('Pen')",
                            src='../../../../assets/images/detective/chapter_1/items/pen.png'
                        )
                        img.detective__items__dictaphone(
                            v-if="items.includes('Dictaphone')",
                            src='../../../../assets/images/detective/chapter_1/items/dictaphone.png'
                        )
                        img.detective__items__book(
                            v-if="items.includes('Book')",
                            src='../../../../assets/images/detective/chapter_1/items/book.png'
                        )
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            items: Array,
            detectiveSrc: String,
            clevikSrc: String,
            isIntroduction: Boolean,
            itemName: String,
            isDialogRunning: Boolean,
            leftImageIsSet: Boolean,
            rightImageIsSet: Boolean,
        },
    }
</script>

<style lang="scss">
    @import "@/assets/sass/detective/conversation-modal.scss";

    .slide-fade-enter-active {
        transition: all .75s ease;
    }
    .slide-fade-leave-active {
        transition: all 1.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }

    #left__conversation-image {
        position: relative;
        height: 100%;
        width: 70%;
        background-repeat: no-repeat;
        background-size: contain;
    }

    #right__conversation-image {
        position: relative;
        height: 100%;
        width: 70%;
        bottom: 1vh;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .columns {
        height: 100%;
        display: flex;
        flex-grow: 1;
    }

    .column {
        display: flex;
        flex-basis: 0;
        flex-grow: 1;
        flex-shrink: 1;
        padding: 0.75rem;
    }

    .center-column {
        width: 25%;
        margin: 0 auto;
        position: relative;
    }

    .room {
        display: flex;
        justify-content: center;
        height: 100vh;
        width: 100%;
    }

    .detective__background, .detective__interior {
        position: absolute;
        height: 100vh;
        width: 100%;
    }

    .detective__interlocutors, .detective__shadows {
        position: absolute;
        height: 100vh;
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .detective__left-interlocutor {
        position: relative;
        height: 65vh;
        top: 0;
        padding-bottom: 2%;
    }

    .detective__left-interlocutor__shadow {
        top: 0;
        position: relative;
        height: 12vh;
        padding-right: 11%;
    }

    .detective__left-interlocutor__shadow_introduction {
        padding-right: 18%;
    }

    .detective__right-interlocutor {
        position: relative;
        height: 80vh;
        right: 12%;
        bottom: 2vh;
    }

    .detective__right-interlocutor_introduction {
        top: 0;
        right: 0;
        padding-left: 2%;
    }

    .detective__right-interlocutor__shadow {
        top: 0;
        position: relative;
        height: 13vh;
    }

    .detective__items {
        position: absolute;
        display: flex;
        flex-direction: column;
        bottom: 23vh;
        height: 28vh;
        left: 63.3%;
        width: calc(80vh / 1.77181208);
    }

    .detective__items__magnifier {
        position: relative;
        height: 11.7vh;
        left: 32%;
    }

    .detective__items__lantern {
        position: relative;
        height: 10.8vh;
        left: 35%;
        top: 1vh;
    }

    .detective__items__notepad {
        position: relative;
        height: 6.36vh;
        left: 16%;
        top: 0.5vh;
    }

    .detective__items__camera {
        position: relative;
        height: 5.75vh;
        left: 20%;
        top: 3vh;
    }

    .detective__items__pen {
        position: relative;
        height: 4.94vh;
        left: 30%;
        bottom: 5vh;
    }

    .detective__items__dictaphone {
        position: relative;
        height: 5.25vh;
        right: 7%;
        bottom: 4.2vh;
    }

    .detective__items__book {
        position: relative;
        height: 6.26vh;
        right: 3%;
        bottom: 1.2vh;
    }

    .detective__items__third-items {
        display: flex;
        align-items: center;
        height: 15vh;
    }

    .left-interlocutor {
        flex-direction: column;
        justify-content: flex-end !important;
    }

    .right-interlocutor {
        flex-direction: column !important;
        align-items: flex-start !important;
        justify-content: flex-end !important;
    }
</style>
